// Guard for AI-Call "test call" — a real ElevenLabs call placed to a tester-picked number.
// The tester explicitly adds targets; we never auto-dial the audience. A few calls go straight
// through; more than a few need an explicit confirm; beyond a hard cap is blocked.
//
// KEEP IN SYNC WITH: cypress/node-tests/ai-call-test-guard.test.js

export const TEST_CALL_CONFIRM_THRESHOLD = 3; // > this many → require an explicit confirm
export const TEST_CALL_MAX = 10;              // hard cap on test calls per run

// A phone is dialable if it has at least 10 digits.
export function isDialableNumber(phone) {
  return typeof phone === 'string' && phone.replace(/\D/g, '').length >= 10;
}

// A target is valid when it names a patient (for script context) and a dialable number.
export function isValidTarget(t) {
  return !!t && t.patNum != null && t.patNum !== '' && isDialableNumber(t.phone);
}

/**
 * Evaluate the tester's target list.
 * @param {Array<{patNum:any, phone:string}>} targets
 * @returns {{ ok:boolean, count:number, reason:?string, needsConfirm:boolean, valid:Array }}
 *   reason ∈ { 'no_targets', 'too_many' } when !ok.
 */
export function evaluateTestTargets(targets) {
  const valid = (targets || []).filter(isValidTarget);
  const count = valid.length;
  if (count === 0) return { ok: false, count, reason: 'no_targets', needsConfirm: false, valid };
  if (count > TEST_CALL_MAX) return { ok: false, count, reason: 'too_many', needsConfirm: false, valid };
  return { ok: true, count, reason: null, needsConfirm: count > TEST_CALL_CONFIRM_THRESHOLD, valid };
}
